/**
 * hooks de detalhe e mutacoes em uma pesquisa especifica.
 */

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type {
  ItemPesquisa,
  ItemPesquisaInput,
  PesquisaDetail,
  StatusPesquisaT,
} from '@licita-mind/shared-types';
import { apiFetch } from '../lib/api';

export const pesquisaQueryKey = (id: string) => ['pesquisas', 'detail', id] as const;

export const useGetPesquisa = (id: string | undefined) =>
  useQuery({
    queryKey: pesquisaQueryKey(id ?? '__none__'),
    queryFn: () => apiFetch<PesquisaDetail>(`/v1/pesquisas/${id}`),
    enabled: !!id,
    staleTime: 5_000,
  });

export const useTransicionarStatus = (id: string) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (novoStatus: StatusPesquisaT) =>
      apiFetch<PesquisaDetail>(`/v1/pesquisas/${id}/transicionar`, {
        method: 'POST',
        body: { novo_status: novoStatus },
      }),
    onSuccess: async (detail) => {
      qc.setQueryData(pesquisaQueryKey(id), detail);
      await qc.invalidateQueries({ queryKey: ['pesquisas'] });
    },
  });
};

export const useAdicionarItem = (id: string) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (item: ItemPesquisaInput) =>
      apiFetch<ItemPesquisa>(`/v1/pesquisas/${id}/itens`, {
        method: 'POST',
        body: item,
      }),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: pesquisaQueryKey(id) });
      await qc.invalidateQueries({ queryKey: ['pesquisas'] });
    },
  });
};
